// extracted by mini-css-extract-plugin
export default {"badge":"styles_badge__aSR-f","originalValue":"styles_originalValue__Bq+L4","requestedValue":"styles_requestedValue__VnlBe","list":"styles_list__ngoMg"};